import { useEffect, useState } from "react";
import API from "../services/api";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Dashboard = () => {
  const [user, setUser] = useState(null);
  const [results, setResults] = useState([]);
  const location = useLocation();
  const [showMsg, setShowMsg] = useState(true);
const message = location.state?.message;
  const navigate = useNavigate();
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setShowMsg(false);
      }, 3000);
  
      return () => clearTimeout(timer);
    }
  }, [message]);

  useEffect(() => {
    const fetchData = async () => {
      const fd = new FormData();
      fd.append("session_id", localStorage.getItem("session_id"));

      try {
        const userRes = await API.post("/auth/get-user.php", fd);
        setUser(userRes.data.user);

        const resultRes = await API.post("/auth/dashboard-results.php", fd);
        setResults(resultRes.data.results || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  if (!user) return <h4 className="text-center mt-5">Loading...</h4>;

  return (
    <div className="dashboard-page">

{message && showMsg && (
  <div className={`alert alert-warning text-center fade-msg`}>
    {message}
  </div>
)}

      <Container className="py-5">

        {/* 🔥 PROFILE HEADER */}
        <div className="profile-header mb-5">
        <Row className="align-items-center">

{/* LEFT - AVATAR */}
<Col md={2} className="text-center">
  <img
    src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
    className="profile-img"
  />
</Col>

{/* CENTER - USER DETAILS */}
<Col md={6}>
  <h3 className="fw-bold mb-1">
    {user.first_name} {user.last_name}
  </h3>

  <p className="text-muted mb-2">{user.email}</p>

  <div className="d-flex gap-4 flex-wrap small text-muted">
    <span>🎓 {user.batch}</span>
    <span>📅 {user.year}</span>
    <span>🆔 {user.roll_no}</span>
  </div>
</Col>

{/* RIGHT - ACTION BUTTONS */}
<Col md={4} className="text-md-end mt-3 mt-md-0">
  <div className="d-flex gap-3 justify-content-md-end flex-wrap">

    <Button
      variant="outline-primary"
      className="action-btn"
      onClick={() => navigate("/instructions")}
    >
      Instructions
    </Button>

    <Button
      className="start-btn"
      onClick={() => navigate("/enter-code")}
    >
      Start Exam
    </Button>

  </div>
</Col>

</Row>
          
        </div>

        {/* 🔥 OVERVIEW CARDS */}
        <Row className="g-3 mb-5">
          <Col md={4}>
            <Card className="overview-card">
              <h4>{results.length}</h4>
              <small>Total Attempts</small>
            </Card>
          </Col>

          <Col md={4}>
            <Card className="overview-card">
              <h4>
                {results[0]
                  ? Math.round((results[0].score / results[0].total) * 100)
                  : 0}%
              </h4>
              <small>Latest Accuracy</small>
            </Card>
          </Col>

          <Col md={4}>
            <Card className="overview-card">
              <h4>
                {results[0]?.score || 0}/{results[0]?.total || 0}
              </h4>
              <small>Latest Score</small>
            </Card>
          </Col>
        </Row>

        {/* 🔥 ATTEMPTS SECTION */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold mb-0">Your Attempts</h5>
        </div>

        {results.length > 0 ? (
          <div className="attempts-scroll">

            {results.map((r, index) => {
              const accuracy = Math.round((r.score / r.total) * 100);

              return (
                <div key={index} className="attempt-card">

                  <h6 className="fw-bold mb-2">Attempt #{index + 1}</h6>

                  <div className="mb-2">
                    <strong>{r.score}/{r.total}</strong>
                    <small className="text-muted"> Score</small>
                  </div>

                  <div className="mb-3">
                    <strong>{accuracy}%</strong>
                    <small className="text-muted"> Accuracy</small>
                  </div>

                  <Button
                    size="sm"
                    className="w-100"
                    onClick={() => navigate(`/result?id=${r.id}`)}
                  >
                    View Result
                  </Button>

                </div>
              );
            })}

          </div>
        ) : (
          <Card className="empty-card text-center p-5 mb-4">
            <h5 className="fw-bold">No Attempts Yet</h5>
            <p className="text-muted">
              Start your first assessment and track your performance here
            </p>
          </Card>
        )}

        {/* 🔥 START BUTTON */}
        {/* <div className="text-center mt-5">
          <Button
            size="lg"
            className="start-btn"
            onClick={() => navigate("/enter-code")}
          >
            Start New Exam →
          </Button>
        </div> */}

      </Container>

      {/* 🔥 PREMIUM CSS */}
      <style>{`
        .dashboard-page {
          background: linear-gradient(135deg,#f5f7fb,#eef2ff);
          min-height: 100vh;
        }
          .fade-msg {
  animation: fadeOut 3s forwards;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}
.action-btn {
  border-radius: 25px;
  padding: 8px 16px;
  font-weight: 500;
}

.start-btn {
  background: linear-gradient(90deg,#0d6efd,#20c997);
  border: none;
  padding: 10px 18px;
  border-radius: 25px;
  font-weight: bold;
  box-shadow: 0 4px 12px rgba(13,110,253,0.3);
}

.start-btn:hover {
  transform: translateY(-1px);
}


        .profile-header {
          background: white;
          padding: 25px;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.08);
        }

        .profile-img {
          width: 90px;
          border-radius: 50%;
          border: 3px solid #0d6efd;
        }

        .overview-card {
          padding: 20px;
          text-align: center;
          border-radius: 14px;
          border: none;
          background: white;
          box-shadow: 0 8px 20px rgba(0,0,0,0.06);
        }

        .attempts-scroll {
          display: flex;
          gap: 20px;
          overflow-x: auto;
          padding-bottom: 10px;
        }

        .attempt-card {
          min-width: 220px;
          background: white;
          padding: 20px;
          border-radius: 14px;
          box-shadow: 0 8px 20px rgba(0,0,0,0.08);
          transition: 0.3s;
        }

        .attempt-card:hover {
          transform: translateY(-5px);
        }

        .empty-card {
          border-radius: 14px;
        }

        .start-btn {
          background: linear-gradient(90deg,#0d6efd,#20c997);
          border: none;
          padding: 14px 40px;
          border-radius: 30px;
          font-weight: bold;
          font-size: 16px;
        }

        /* scrollbar clean */
        .attempts-scroll::-webkit-scrollbar {
          height: 6px;
        }

        .attempts-scroll::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 10px;
        }
      `}</style>

    </div>
  );
};

export default Dashboard;